import createMailFolderTableQuery from './createMailFolderTableQuery';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { updateWatermarkAndResetRollup } from 'owa-mail-focused-inbox-rollup-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { orchestrator } from 'satcheljs';
import { ActionSource } from 'owa-mail-store';
import { listViewStore } from 'owa-mail-list-store';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

// Select focused view filter
const selectFocusedViewFilter = action(
    'selectFocusedViewFilter',
    (focusedViewFilter: FocusedViewFilter, actionSource: ActionSource) =>
        addDatapointConfig(
            {
                name: 'TnS_SelectPivot',
                options: { isCore: true },
                customData: [
                    focusedViewFilter,
                    actionSource,
                    listViewStore.inboxPausedDateTime != null /* isInboxPaused */,
                ],
            },
            {
                focusedViewFilter,
                actionSource,
            }
        )
);

orchestrator(selectFocusedViewFilter, ({ focusedViewFilter }) => {
    const selectedTableView = getSelectedTableView();

    // Update last visit watermark for selected pivot and reset rollup data
    updateWatermarkAndResetRollup(focusedViewFilter, 'NonUserAction');

    // Always reset the view filter when user switches the focused pivot
    const tableQuery = createMailFolderTableQuery(
        selectedTableView.tableQuery.folderId,
        selectedTableView.tableQuery.listViewType,
        'mail',
        focusedViewFilter,
        null /* viewFilter */,
        null /* categoryName */,
        null /* sortBy */,
        focusedViewFilter === FocusedViewFilter.Focused
            ? InboxClassificationFilter.Focused
            : InboxClassificationFilter.Other
    );

    return loadTableViewFromTableQuery(tableQuery);
});

export default selectFocusedViewFilter;
